export default __webpack_public_path__ + "static/media/char5.934e1658.svg";